import { render, staticRenderFns } from "./TeamDetails.vue?vue&type=template&id=55cd930c"
import script from "./TeamDetails.vue?vue&type=script&lang=js"
export * from "./TeamDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports